import React from "react";
import { useState, useEffect, useContext } from "react";
import { ApiClient } from "../utils/apiclient";
import { getIcon, getStoredUserData } from "../utils/utils";
import { IMenuItem, Notification } from "../utils/types";
import NotificationView from "./notification_view";
import MenuButton from "./menu_button";
import { useRouter } from "next/navigation";
import { useNavigate } from "react-router-dom";
import { CareLogoImage } from "./image-assets";
import Image from './image'
// import { DialogContext } from "../layout";


const Sidebar = (props: any) => {
    const navigate = useNavigate()
    const userData = props.user;
    const menuItems = userData?.menuItems
    // const { showDialog, setShowDialog } = useContext(DialogContext);


    const handleMenuButtonClick = (id: number) => {
        const selectedMenuItem = menuItems.find((menuItem: IMenuItem) => menuItem.id == id)
        if (selectedMenuItem?.text == 'Sign out') {
            // setShowDialog(true);
        }
        else {
            const path = selectedMenuItem?.text.toLocaleLowerCase();
            navigate(`/${path}`)
        }
    }


    return (<div className="md:fixed bottom-0 start-0 bg-slate-100 h-full px-6 w-2/12">
        {props.user ? <>
            <Image src={CareLogoImage} className="w-6/12 m-2" />
            <nav className="w-full space-y-4 flex flex-col mt-8">
                {menuItems && menuItems.map((menuItem: IMenuItem) => {
                    let newIcon = {
                        id: menuItem.id,
                        text: menuItem.text,
                        icon: getIcon(menuItem.icon),
                    }
                    return newIcon;
                }).map((menuItem: IMenuItem) => {
                    return (
                        <MenuButton
                            key={menuItem.id}
                            id={menuItem.id}
                            icon={menuItem.icon}
                            text={menuItem.text}
                            isActive={props.active}
                            clicked={menuItem.clicked}
                            onButtonClick={(id: number) => {
                                handleMenuButtonClick(id);
                            }}
                        />
                    );
                })}
            </nav>
            {/* <div className="bg-red-900 flex-col justify-center">
                <MenuButton
                    key={'signout'}
                    id={7}
                    icon={'exit_to_app'}
                    text={"Sign out"}
                    clicked={false}
                    onButtonClick={(id: number) => {
                        handleMenuButtonClick(id);
                    }} />
            </div> */}
        </> : null}
    </div>
    )
}

export default Sidebar;